import * as React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import CommonSortIcon from "components/common/SortIcon";
const StyledCommonSortIcon = styled(CommonSortIcon)(
  ({ theme, $isRightAligned }) => css`
    display: inline-flex;
    // Mirrors the rest of the header for right-aligned (numeric) columns: the indicator icons sit
    // on the other side of the title there, so the margin needs to face the other way too.
    ${$isRightAligned ? css`
          margin-right: ${theme.spacings.xs};
        ` : css`
          margin-left: ${theme.spacings.xs};
        `}
    padding: 0;
    cursor: pointer;
  `
);
const SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc"
};
const SORT_TITLES = {
  asc: "entity_table.sort_column_ascending",
  desc: "entity_table.sort_column_descending"
};
const SortIcon = ({ column }) => {
  var _a;
  const { t } = useTranslation("common");
  const nextSortDirection = column.getNextSortingOrder() || SORT_DIRECTIONS.ASC;
  const columnMeta = column.columnDef.meta;
  const isRightAligned = ((_a = columnMeta == null ? void 0 : columnMeta.columnRenderer) == null ? void 0 : _a.textAlign) === "right";
  return /* @__PURE__ */ React.createElement(
    StyledCommonSortIcon,
    {
      activeDirection: column.getIsSorted() || null,
      onChange: () => column.toggleSorting(),
      title: t(SORT_TITLES[nextSortDirection], { column: columnMeta.label }),
      ascId: SORT_DIRECTIONS.ASC,
      descId: SORT_DIRECTIONS.DESC,
      $isRightAligned: isRightAligned
    }
  );
};
export default SortIcon;
